// Walldora bileşen davranışları (Faz 3): sheet/modal, favori, toast.
// Sayfada bir kez, modül olarak yüklenir.

// ---- sheet ve modal: yerleşik <dialog>, odak tuzağı ve Esc tarayıcıdan ----
// Açan: [data-wd-open="dialog-id"] · kapatan: [data-wd-close] · arka plana tık kapatır
document.addEventListener("click", (event) => {
  const opener = event.target.closest("[data-wd-open]");
  if (opener) {
    const dialog = document.getElementById(opener.dataset.wdOpen);
    if (dialog && typeof dialog.showModal === "function") {
      event.preventDefault();
      dialog.showModal();
      document.documentElement.classList.add("wd-lock");
    }
    return;
  }
  const closer = event.target.closest("[data-wd-close]");
  if (closer) {
    closer.closest("dialog")?.close();
    return;
  }
  if (event.target instanceof HTMLDialogElement && event.target.classList.contains("wd-sheet")) {
    event.target.close();
  }
});
document.addEventListener(
  "close",
  (event) => {
    if (event.target instanceof HTMLDialogElement && !document.querySelector("dialog[open]")) {
      document.documentElement.classList.remove("wd-lock");
    }
  },
  true
);

// ---- toast. Onay yeşili kullanılmaz (kural 9): bilgi koyu, hata kırmızı ----
function toastRegion() {
  let region = document.querySelector(".wd-toast-region");
  if (!region) {
    region = document.createElement("div");
    region.className = "wd-toast-region";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    document.body.append(region);
  }
  return region;
}

export function toast(message, { tone = "info", duration = 3200 } = {}) {
  const el = document.createElement("div");
  el.className = tone === "danger" ? "wd-toast wd-toast--danger" : "wd-toast";
  el.textContent = message;
  toastRegion().append(el);
  setTimeout(() => el.remove(), duration);
}
window.wdToast = toast;

// ---- favori: şimdilik cihazda (localStorage). Saved sayfası ve hesap senkronu sonra ----
const SAVED_KEY = "wd-saved";

function readSaved() {
  try {
    return new Set(JSON.parse(localStorage.getItem(SAVED_KEY) || "[]"));
  } catch {
    return new Set();
  }
}

function writeSaved(set) {
  try {
    localStorage.setItem(SAVED_KEY, JSON.stringify([...set]));
    return true;
  } catch {
    return false;
  }
}

function syncSaveButtons(root = document) {
  const saved = readSaved();
  root.querySelectorAll("[data-wd-save]").forEach((button) => {
    button.setAttribute("aria-pressed", String(saved.has(button.dataset.wdSave)));
  });
}

// Kalp atışı: sınıf yeniden eklenince animasyon baştan oynar
export function pop(el) {
  el.classList.remove("is-pop");
  void el.offsetWidth;
  el.classList.add("is-pop");
  el.addEventListener("animationend", () => el.classList.remove("is-pop"), { once: true });
}
window.wdPop = pop;

// Favori olayı backend'e de gider (DURUM "Favoriler"): kim neyi eklemiş yönetim panelinde.
// Kimlik Studio ile aynı (müşteri ya da cihaz). Başarısızlık sessiz: cihazdaki liste esastır
function reportFavorite(action, handle, extra = {}) {
  import("walldora-studio")
    .then(({ api }) => api("/favorite", { method: "POST", body: { action, handle, ...extra } }))
    .catch(() => {});
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-wd-save]");
  if (!button) return;
  const saved = readSaved();
  const handle = button.dataset.wdSave;
  const nowSaved = !saved.has(handle);
  if (nowSaved) saved.add(handle);
  else saved.delete(handle);
  if (!writeSaved(saved)) {
    toast(document.documentElement.dataset.wdToastError || "Something went wrong. Try again", { tone: "danger" });
    return;
  }
  syncSaveButtons();
  if (nowSaved) pop(button);
  const title = button.dataset.title || button.closest(".wd-card")?.querySelector(".wd-card__name")?.textContent?.trim();
  reportFavorite(nowSaved ? "add" : "remove", handle, { title });
});

syncSaveButtons();

// ---- favori yardımcısı: PDP "Save this size" ürünü favorilere de ekler ----
window.wdSave = {
  has: (handle) => readSaved().has(handle),
  // Ölçüyle kayıtta (size verilirse) olay "size", yoksa "add"
  add(handle, { title, size } = {}) {
    const saved = readSaved();
    saved.add(handle);
    const ok = writeSaved(saved);
    syncSaveButtons();
    if (ok) reportFavorite(size ? "size" : "add", handle, { title, size });
    return ok;
  },
};

// ---- "eklendi" anı: sepet, numune, kayıt (DURUM "Eklendi geri bildirimi") ----
// Görselin küçük kopyası hedef ikona (header sepeti ya da kalbi) uçar, ikon zıplar; header'ın
// altında bir kart çıkar: yeşil onay, ürün, ayrıntı, fiyat, eylemler. Kart 6 sn sonra kapanır,
// üstüne gelince ya da içinde odak varken bekler. Azaltılmış harekette uçuş ve kayma yok.
const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Görünen ilk hedef: masaüstünde header ikonu, mobilde gerekirse alt gezinme
export function visibleTarget(selectors) {
  for (const selector of selectors) {
    for (const el of document.querySelectorAll(selector)) {
      const r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return el;
    }
  }
  return null;
}

export function fly(fromImg, target) {
  if (!fromImg || !target || reducedMotion() || !fromImg.animate) return;
  const a = fromImg.getBoundingClientRect();
  const b = target.getBoundingClientRect();
  if (!a.width || !b.width) return;
  const size = Math.min(a.width, a.height) * 0.4;
  const x = a.left + a.width / 2 - size / 2;
  const y = a.top + a.height / 2 - size / 2;
  const ghost = document.createElement("img");
  ghost.src = fromImg.currentSrc || fromImg.src;
  ghost.alt = "";
  ghost.className = "wd-fly";
  Object.assign(ghost.style, { left: `${x}px`, top: `${y}px`, width: `${size}px`, height: `${size}px` });
  document.body.append(ghost);
  const dx = b.left + b.width / 2 - (x + size / 2);
  const dy = b.top + b.height / 2 - (y + size / 2);
  const lift = Math.min(a.height * 0.25, Math.abs(dy) + size);
  ghost
    .animate(
      [
        { transform: "translate(0, 0) scale(1)", opacity: 1 },
        { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - lift}px) scale(0.6)`, opacity: 1, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.1)`, opacity: 0.3 },
      ],
      { duration: 760, easing: "cubic-bezier(0.5, 0, 0.25, 1)" }
    )
    .finished.then(() => {
      ghost.remove();
      target.animate(
        [{ transform: "scale(1)" }, { transform: "scale(1.28)" }, { transform: "scale(0.94)" }, { transform: "scale(1)" }],
        { duration: 420, easing: "ease-out" }
      );
    })
    .catch(() => ghost.remove());
}

const CHECK_SVG = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
const CLOSE_SVG = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

export function added({ title, image, name, detail, price, actions = [], closeLabel = "Close" }) {
  document.querySelector(".wd-added")?.remove();
  const card = document.createElement("div");
  card.className = "wd-added";
  card.setAttribute("role", "status");
  card.setAttribute("aria-live", "polite");

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const head = el("div", "wd-added__head");
  const check = el("span", "wd-added__check");
  check.innerHTML = CHECK_SVG;
  const close = el("button", "wd-added__close");
  close.type = "button";
  close.setAttribute("aria-label", closeLabel);
  close.innerHTML = CLOSE_SVG;
  head.append(check, el("span", "wd-added__title", title), close);

  const body = el("div", "wd-added__body");
  if (image) {
    const img = el("img", "wd-added__thumb");
    img.src = image;
    img.alt = "";
    img.width = 64;
    img.height = 64;
    body.append(img);
  }
  const text = el("span", "wd-added__text");
  text.append(el("span", "wd-added__name", name), el("span", "wd-added__detail", detail));
  body.append(text, el("span", "wd-added__price", price || ""));

  const row = el("div", "wd-added__actions");
  actions.forEach((a) => {
    const link = el("a", `wd-btn wd-btn--sm ${a.primary ? "wd-btn--primary" : "wd-btn--outline"}`, a.label);
    link.href = a.href;
    row.append(link);
  });
  card.append(head, body, row);
  document.body.append(card);

  let timer = null;
  const hide = () => {
    card.classList.remove("is-in");
    setTimeout(() => card.remove(), reducedMotion() ? 0 : 320);
  };
  const arm = () => {
    clearTimeout(timer);
    timer = setTimeout(hide, 6000);
  };
  close.addEventListener("click", hide);
  card.addEventListener("mouseenter", () => clearTimeout(timer));
  card.addEventListener("mouseleave", arm);
  card.addEventListener("focusin", () => clearTimeout(timer));
  card.addEventListener("focusout", (event) => {
    if (!card.contains(event.relatedTarget)) arm();
  });
  requestAnimationFrame(() => requestAnimationFrame(() => card.classList.add("is-in")));
  arm();
}

window.wdAdded = added;
window.wdFly = fly;
window.wdVisibleTarget = visibleTarget;

// ---- Studio tasarımları da favori (DURUM "Favoriler" F5) ----
// Cihazda wd-saved-designs (Favorites "From your studio", See It'in seçicisi), olay backend'e de
// gider; oturum açmış müşteride hesap esastır (syncFavorites). Görseli sunucu tasarımdan okur
const DESIGNS_KEY = "wd-saved-designs";
function readDesigns() {
  try {
    const list = JSON.parse(localStorage.getItem(DESIGNS_KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}
function writeDesigns(list) {
  try {
    localStorage.setItem(DESIGNS_KEY, JSON.stringify(list.slice(-300)));
    return true;
  } catch {
    return false;
  }
}
window.wdSaveDesign = {
  list: readDesigns,
  has: (id) => readDesigns().some((d) => d.id === id),
  // d: { id, thumb, format, mode }. Döner: şimdi kayıtlı mı
  toggle(d) {
    const list = readDesigns();
    const on = list.some((x) => x.id === d.id);
    const next = on ? list.filter((x) => x.id !== d.id) : [...list, { id: d.id, thumb: d.thumb, format: d.format, mode: d.mode, at: Date.now() }];
    if (!writeDesigns(next)) return on;
    import("walldora-studio")
      .then(({ api }) => api("/favorite", { method: "POST", body: { kind: "design", action: on ? "remove" : "add", id: d.id } }))
      .catch(() => {});
    return !on;
  },
};

// ---- cihazlar arası favoriler (DURUM "Favoriler" F4) ----
// Oturum açmış müşteride sunucudaki liste esastır: sayfa açılınca (en fazla iki dakikada bir,
// Favorites sayfasında her açılışta) cihazdaki liste ve ölçü kayıtları onunla değiştirilir.
// Bu cihaz bu hesapla ilk kez eşleşirken cihazdaki liste hesaba katılır. Misafirde yalnız cihaz.
function readSizes() {
  try {
    return JSON.parse(localStorage.getItem("wd-saved-sizes") || "{}") || {};
  } catch {
    return {};
  }
}

async function syncFavorites() {
  const customer = document.documentElement.dataset.wdCustomer;
  if (!customer) return;
  const mergedKey = `wd-fav-merged:${customer}`;
  let merged = false;
  let last = 0;
  try {
    merged = localStorage.getItem(mergedKey) === "1";
    last = Number(sessionStorage.getItem("wd-fav-sync-at") || 0);
  } catch {}
  // Studio tasarımları ayrı eşlenir: bu cihaz ürünleri daha önce eşlemiş olabilir
  const designsKey = `wd-fav-designs-merged:${customer}`;
  let designsMerged = false;
  try {
    designsMerged = localStorage.getItem(designsKey) === "1";
  } catch {}
  const onFavorites = Boolean(document.querySelector("[data-wd-saved], wd-studio2"));
  if (merged && designsMerged && !onFavorites && Date.now() - last < 120000) return;

  const sizes = readSizes();
  const items = merged
    ? []
    : [...readSaved()].map((handle) => {
        const s = sizes[handle];
        return s ? { handle, size: { w: s.w, h: s.h, text: s.size, material: s.material, variant: s.variant } } : { handle };
      });
  const { api } = await import("walldora-studio");
  const designs = designsMerged ? [] : readDesigns().map((d) => ({ id: d.id, at: d.at }));
  const r = await api("/favorites/sync", { method: "POST", body: { merge: !merged, items, mergeDesigns: !designsMerged, designs } });
  if (!Array.isArray(r?.items)) return;
  if (Array.isArray(r.designs)) {
    writeDesigns(r.designs);
    try {
      localStorage.setItem(designsKey, "1");
    } catch {}
  }

  writeSaved(new Set(r.items.map((i) => i.handle)));
  const next = {};
  r.items.forEach((i) => {
    if (!i.size) return;
    next[i.handle] = { w: i.size.w, h: i.size.h, variant: i.size.variant, unit: sizes[i.handle]?.unit || "imperial", material: i.size.material, size: i.size.text };
  });
  try {
    localStorage.setItem("wd-saved-sizes", JSON.stringify(next));
    localStorage.setItem(mergedKey, "1");
    sessionStorage.setItem("wd-fav-sync-at", String(Date.now()));
  } catch {}
  syncSaveButtons();
  document.dispatchEvent(new CustomEvent("wd:favorites-synced"));
}

// Favorites sayfası listeyi çizmeden önce bunu bekler (saved.js)
window.wdFavoritesReady = syncFavorites().catch(() => {});

// ---- lightbox: görsel galerisi (Favorites "On my walls", DURUM S2-31) ----------------
// Koyu perde, ortada görsel, oklar, klavye ve kaydırma; altta başlık, künye, sayaç ve
// isteğe bağlı eylem. items: [{ src, width, height, alt, title, meta, note, href, cta }]
let lightboxEl = null;
export function lightbox({ items, index = 0, labels = {} }) {
  if (!items?.length) return;
  const L = { prev: "Previous", next: "Next", close: "Close", ...labels };
  if (!lightboxEl) {
    lightboxEl = document.createElement("dialog");
    lightboxEl.className = "wd-lightbox";
    lightboxEl.innerHTML = `
      <div class="wd-lightbox__stage" data-lb-stage>
        <button type="button" class="wd-lightbox__nav wd-lightbox__nav--prev" data-lb-step="-1"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>
        <img class="wd-lightbox__img" data-lb-img alt="">
        <button type="button" class="wd-lightbox__nav wd-lightbox__nav--next" data-lb-step="1"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>
      </div>
      <div class="wd-lightbox__bar">
        <div class="wd-lightbox__text">
          <span class="wd-lightbox__title" data-lb-title></span>
          <span class="wd-lightbox__meta" data-lb-meta></span>
          <span class="wd-lightbox__note" data-lb-note></span>
        </div>
        <span class="wd-lightbox__count" data-lb-count aria-live="polite"></span>
        <a class="wd-lightbox__cta" data-lb-cta href="#"><span></span><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
      </div>
      <button type="button" class="wd-lightbox__close" data-lb-close><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>`;
    document.body.append(lightboxEl);
    const el = lightboxEl;
    el.addEventListener("click", (event) => {
      const step = event.target.closest("[data-lb-step]");
      if (step) return el.wdShow(el.wdIndex + Number(step.dataset.lbStep));
      if (event.target.closest("[data-lb-close]") || event.target === el || event.target.matches("[data-lb-stage]")) el.close();
    });
    el.addEventListener("keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return;
      event.preventDefault();
      el.wdShow(el.wdIndex + (event.key === "ArrowRight" ? 1 : -1));
    });
    // Dokunmatik: yana kaydırma önceki ya da sonraki
    let startX = null;
    el.addEventListener("pointerdown", (event) => (startX = event.pointerType === "touch" ? event.clientX : null));
    el.addEventListener("pointerup", (event) => {
      if (startX == null) return;
      const dx = event.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 48) el.wdShow(el.wdIndex + (dx < 0 ? 1 : -1));
    });
  }
  const el = lightboxEl;
  el.querySelector('[data-lb-step="-1"]').setAttribute("aria-label", L.prev);
  el.querySelector('[data-lb-step="1"]').setAttribute("aria-label", L.next);
  el.querySelector("[data-lb-close]").setAttribute("aria-label", L.close);
  el.querySelectorAll("[data-lb-step]").forEach((b) => (b.hidden = items.length < 2));
  el.wdShow = (i) => {
    el.wdIndex = (i + items.length) % items.length;
    const it = items[el.wdIndex];
    const img = el.querySelector("[data-lb-img]");
    img.classList.remove("is-in");
    void img.offsetWidth;
    img.src = it.src;
    img.alt = it.alt || "";
    if (it.width && it.height) {
      img.width = it.width;
      img.height = it.height;
    }
    img.classList.add("is-in");
    el.querySelector("[data-lb-title]").textContent = it.title || "";
    el.querySelector("[data-lb-meta]").textContent = it.meta || "";
    el.querySelector("[data-lb-note]").textContent = it.note || "";
    el.querySelector("[data-lb-count]").textContent = items.length > 1 ? `${el.wdIndex + 1} / ${items.length}` : "";
    const cta = el.querySelector("[data-lb-cta]");
    cta.hidden = !it.href;
    if (it.href) {
      cta.href = it.href;
      cta.querySelector("span").textContent = it.cta || "";
    }
  };
  el.wdShow(index);
  if (!el.open) {
    el.showModal();
    document.documentElement.classList.add("wd-lock");
  }
}
window.wdLightbox = lightbox;
